import { render, staticRenderFns } from "./app-session-notifier.vue?vue&type=template&id=592c5a93&"
import script from "./app-session-notifier.vue?vue&type=script&lang=js&"
export * from "./app-session-notifier.vue?vue&type=script&lang=js&"
import style0 from "./app-session-notifier.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports